import { render, staticRenderFns } from "./DEFAULT.vue?vue&type=template&id=b401a35c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/kccp/PROD/kccp-portal-web-internet-dynamic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b401a35c', component.options)
    } else {
      api.reload('b401a35c', component.options)
    }
    module.hot.accept("./DEFAULT.vue?vue&type=template&id=b401a35c&", function () {
      api.rerender('b401a35c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/request/new/DEFAULT.vue"
export default component.exports